import { ILLCompany, ISSDPConctact, IImporter } from './index';

export class IEstablishment {
  establishmentId: number;
  establishmentName: string;
  sequence: number;
  establishmentCompany: ILLCompany;
  establishmentContact: ISSDPConctact;
  usAgentCompany: ILLCompany;
  usAgentContact: ISSDPConctact;
  importers: IImporter[];
}
